import { Component, ElementRef, OnInit, ViewChild, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { MapConfig } from '../../../../environments/environment';
declare const google;
@Component({
    selector: 'app-airportmapview',
    templateUrl: './airportmapview.page.html',
    styleUrls: ['./airportmapview.page.scss'],
    standalone: false
})
export class AirportmapviewPage implements OnInit {
 public drawerOptions: any = {
    handleHeight: 50,
    thresholdFromBottom: 200,
    thresholdFromTop: 200,
    bounceBack: true,
    Title: "Flight Planning"
  };
  @ViewChild('map') public mapElement: ElementRef;
  @Input() public airportInfo: any;
  @Input() public data: any;
  public map: any;
  public RouteInforamtion: any;
  public routeDetails:any;
  public stationType = [];
  public myStyle = [


    {
      "featureType": "administrative.neighborhood",
      "elementType": "labels",
      "stylers": [{
        "visibility": "off"
      }]
    }, {
      "featureType": "administrative.land_parcel",
      "elementType": "labels",
      "stylers": [{
        "visibility": "off"
      }]
    }, {
      "featureType": "administrative.locality",
      "elementType": "labels",
      "stylers": [{
        "visibility": "off"
      }]
    },


    {
      "featureType": "landscape.natural",
      "elementType": "geometry.fill",
      "stylers": [
        {
          "visibility": "on"
        },
        {
          "color": "#e0efef"
        }
      ]
    },
    {
      "featureType": "poi.park",
      "elementType": "labels.text",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "featureType": "poi",
      "elementType": "geometry.fill",
      "stylers": [
        {
          "visibility": "on"
        },
        {
          "hue": "#1900ff"
        },
        {
          "color": "#c0e8e8"
        }
      ]
    },
    {
      "featureType": "road",
      "elementType": "geometry",
      "stylers": [
        {
          "lightness": 100
        },
        {
          "visibility": "simplified"
        }
      ]
    },
    {
      "featureType": "road",
      "elementType": "labels",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "featureType": "transit.line",
      "elementType": "geometry",
      "stylers": [
        {
          "visibility": "on"
        },
        {
          "lightness": 700
        }
      ]
    },
    {
      "featureType": "water",
      "elementType": "all",
      "stylers": [
        {
          "color": "#C5EFFD"
        }
      ]
    }
  ];
  public title:string="";
  constructor(private modalCtrl:ModalController) { }

  public ngOnInit() {
    this.title = this.airportInfo.Name;
    this.routeDetails = this.data;
  }
 public ngAfterViewInit(): void {
    this.loadMap();
  }
 public loadMap() {
    const latLng = new google.maps.LatLng(this.routeDetails.lat, this.routeDetails.lng);
    const configuredMapId =
      MapConfig.googleMapId && MapConfig.googleMapId !== 'DEMO_MAP_ID'
        ? MapConfig.googleMapId
        : '';
    const mapOptions: any = {
      center: latLng,
      maxZoom: 9,
      minZoom: 9,
      zoom: 9,
      tilt: 45,
      scaleControl: false,
      navigationControl: false,
      streetViewControl: false
      // disableDefaultUI: true
    };
    if (configuredMapId) {
      mapOptions.mapId = configuredMapId;
    }
    if (!configuredMapId) {
      const politicalStyleOverrides = [
        { featureType: 'road', elementType: 'all', stylers: [{ visibility: 'off' }] },
        { featureType: 'transit', elementType: 'all', stylers: [{ visibility: 'off' }] },
        { featureType: 'poi', elementType: 'labels', stylers: [{ visibility: 'off' }] },
      ];
      mapOptions.styles = [...this.myStyle, ...politicalStyleOverrides];
    }

    this.map = new google.maps.Map(this.mapElement.nativeElement, mapOptions);
    const hasValidMapId = !!(MapConfig.googleMapId && MapConfig.googleMapId !== 'DEMO_MAP_ID');
    const AdvancedMarkerElement = google.maps?.marker?.AdvancedMarkerElement;
    if (hasValidMapId && AdvancedMarkerElement) {
      const markerContent = document.createElement('div');
      markerContent.style.display = 'inline-flex';
      markerContent.style.alignItems = 'center';
      markerContent.style.justifyContent = 'center';
      markerContent.style.background = '#1e88e5';
      markerContent.style.color = '#fff';
      markerContent.style.padding = '4px 8px';
      markerContent.style.borderRadius = '12px';
      markerContent.style.fontSize = '11px';
      markerContent.style.fontWeight = '600';
      markerContent.textContent = this.routeDetails.icao;
      this.createAdvancedMarker(AdvancedMarkerElement, {
        map: this.map,
        position: latLng,
        content: markerContent,
        title: this.routeDetails.icao,
      });
    } else {
      this.addOverlayMarker({ lat: this.routeDetails.lat, lng: this.routeDetails.lng }, this.routeDetails.icao);
    }

    this.drawOverlays();
  }
  public drawOverlays() {
    const airacCyleIndex = this.getAiracCycle();
    const basic = new google.maps.ImageMapType({
      getTileUrl: (coord, zoom) =>{
        return 'https://t.skyvector.com/4WFYbW00p0mIz9kG/basic/' + airacCyleIndex + '/' + zoom + '/' + coord.x + '/' + coord.y + '.jpg';
      },
      tileSize: new google.maps.Size(256, 256)
    });
    this.map.overlayMapTypes.insertAt(0, basic);
    const hiOverlay = new google.maps.ImageMapType({
      getTileUrl: (coord, zoom) => {
        return 'https://t.skyvector.com/4WFYbW00p0mIz9kG/vfr/' + airacCyleIndex + '/' + zoom + '/' + coord.x + '/' + coord.y + '.jpg';
      },
      tileSize: new google.maps.Size(256, 256)
   });
    this.map.overlayMapTypes.insertAt(1
      , hiOverlay);
  }
 public getAiracCycle() {
    const list = ['1701', '1702', '1703', '1704', '1705', '1706', '1707', '1708', '1709', '1710', '1711', '1712', '1713', '1801', '1802', '1803', '1804', '1805', '1806', '1807', '1808', '1809', '1810', '1811', '1812', '1813', '1901', '1902', '1903', '1904', '1905', '1906', '1907', '1908', '1909', '1910', '1911', '1912', '1913', '2001', '2002', '2003', '2004', '2005', '2006', '2007', '2008', '2009', '2010', '2011', '2012', '2013', '2014', '2101', '2102', '2103', '2104', '2105', '2106', '2107', '2108', '2109', '2110', '2111', '2112', '2113', '2201', '2202', '2203', '2204', '2205', '2206', '2207', '2208', '2209', '2210', '2211', '2212', '2213', '2301', '2302', '2303', '2304', '2305', '2306', '2307', '2308', '2309', '2310', '2311', '2312', '2313', '2401', '2402', '2403', '2404', '2405', '2406', '2407', '2408', '2409', '2410', '2411', '2412', '2413', '2501', '2502', '2503', '2504', '2505', '2506', '2507', '2508', '2509', '2510', '2511', '2512', '2513', '2601', '2602', '2603', '2604', '2605', '2606', '2607', '2608', '2609', '2610', '2611', '2612', '2613'];
    const today = new Date();
    const seconds = Math.round(today.getTime() / 1000);
    const cycleIndex = Math.floor((seconds - 1483606860) / 2419200);
    return list[cycleIndex];
  }
  public dismiss() {
    this.modalCtrl.dismiss();
  }
  private addOverlayMarker(position: { lat: number; lng: number }, label: string): void {
    class AirportOverlay extends google.maps.OverlayView {
      private div: HTMLDivElement | null = null;
      constructor(private pos: { lat: number; lng: number }, private text: string) {
        super();
      }
      public onAdd() {
        this.div = document.createElement('div');
        this.div.style.position = 'absolute';
        this.div.style.transform = 'translate(-50%, -100%)';
        this.div.style.display = 'inline-flex';
        this.div.style.alignItems = 'center';
        this.div.style.justifyContent = 'center';
        this.div.style.background = '#1e88e5';
        this.div.style.color = '#fff';
        this.div.style.padding = '4px 8px';
        this.div.style.borderRadius = '12px';
        this.div.style.fontSize = '11px';
        this.div.style.fontWeight = '600';
        this.div.textContent = this.text;
        const panes = this.getPanes();
        panes?.overlayMouseTarget.appendChild(this.div);
      }
      public draw() {
        if (!this.div) {
          return;
        }
        const projection = this.getProjection();
        const pixel = projection?.fromLatLngToDivPixel(new google.maps.LatLng(this.pos.lat, this.pos.lng));
        if (!pixel) {
          return;
        }
        this.div.style.left = `${pixel.x}px`;
        this.div.style.top = `${pixel.y}px`;
      }
      public onRemove() {
        this.div?.remove();
        this.div = null;
      }
    }
    const overlay = new AirportOverlay(position, label);
    overlay.setMap(this.map);
  }

  private createAdvancedMarker(AdvancedMarkerElement: any, options: any): any {
    return new AdvancedMarkerElement(options);
  }
}
